module.exports = __webpack_public_path__ + "img/about-m-slide-16.00922ef4.jpg";